import { render } from "./AskActions.vue?vue&type=template&id=16998005&scoped=true"
import script from "./AskActions.vue?vue&type=script&lang=js"
export * from "./AskActions.vue?vue&type=script&lang=js"

import "./AskActions.vue?vue&type=style&index=0&id=16998005&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16998005"]])

export default __exports__